import { GET_MANAGE_PROFILE_SUCCESS, UPDATE_USER_INFO_SUCCESS, UPDATE_AU_SETTINGS_SUCCESS, RESET_USER_INFO, SET_UPDATING_DATA, CREATE_USER_LICENSE_SUCCESS, UPDATE_USER_LICENSE_SUCCESS, DELETE_USER_LICENSE_SUCCESS, GET_NOTIFICATION_SETTINGS_SUCCESS, GET_NOTIFICATION_SETTINGS_FAILURE, UPDATE_NOTIFICATION_SETTINGS_SUCCESS } from "../actions/actionConstants";
import {sortArrayByKey} from "../../../common/util";
import { mapApiToUi } from "../ManageProfile/notificationSettingsMapper";

const initialState = {
    userInfo: {},
    updatingData: null,
    timezoneData:{},
    notificationSettings: {},
    notificationSettingsError: null
};

export default function (state = initialState, action) {
    switch (action.type) {
        case GET_MANAGE_PROFILE_SUCCESS: {
            return Object.assign({}, state, { 
                userInfo: action.payload
            });
        }
        case UPDATE_USER_INFO_SUCCESS: {
            const updateData = action.payload;
            let updateUserInfo = {};
            if (updateData.mode == "phone") {
                updateUserInfo = Object.assign({}, state.userInfo, { Telephone: updateData.phone });
                return Object.assign({}, state, { userInfo: updateUserInfo });
            }
            else if (updateData.mode == "name") {
                updateUserInfo = Object.assign({}, state.userInfo, { FirstName: updateData.firstName, MiddleName: updateData.middleName, LastName: updateData.lastName });
                return Object.assign({}, state, { userInfo: updateUserInfo });
            }
            else if(updateData.mode == "UserTimezone"){
                updateUserInfo = Object.assign({}, state.userInfo, { UserTimezone: updateData.timeZoneId, UserTimezoneDisplayValue:updateData.timeZoneValue});
                return Object.assign({}, state, { userInfo: updateUserInfo });
            }
        }
        case UPDATE_AU_SETTINGS_SUCCESS: {
           // let obj = Object.assign({}, state.userInfo);
            //obj[action.payload.type] = action.payload.isActivityUpdateNeeded;
            return Object.assign({}, state, { userInfo: action.payload.auSettings });
        };

        case GET_NOTIFICATION_SETTINGS_SUCCESS: {
            return Object.assign({}, state, { notificationSettings: mapApiToUi(action.payload), notificationSettingsError: null });
        }

        case GET_NOTIFICATION_SETTINGS_FAILURE: {
            // existing users created before this API don't have a settings row yet - surface the error as-is.
            // new users are always provisioned with a row by the backend, so this won't happen for them.
            const message = (action.payload && action.payload.message) || "Unable to load notification settings.";
            return Object.assign({}, state, { notificationSettingsError: message });
        }

        case UPDATE_NOTIFICATION_SETTINGS_SUCCESS: {
            return Object.assign({}, state, { notificationSettings: mapApiToUi(action.payload), notificationSettingsError: null });
        }

        case SET_UPDATING_DATA: {
            return Object.assign({}, state, { updatingData: action.payload.key });
        }

        case RESET_USER_INFO:
            return initialState;

        case CREATE_USER_LICENSE_SUCCESS: {
            let obj = Object.assign({}, state.userInfo);            
            let UserLicensesData = [].concat(obj.UserLicenses, action.payload);
            sortArrayByKey(UserLicensesData,"State");
            obj = Object.assign({}, obj, {UserLicenses : UserLicensesData});
            return Object.assign({}, state, { userInfo: obj });
        }

        case UPDATE_USER_LICENSE_SUCCESS: {
            let obj = Object.assign({}, state.userInfo);
            var ulData = [];         
            var newRecords = obj.UserLicenses.filter(item => item.State != action.payload.State);
            ulData = newRecords.length > 0 ? [].concat(newRecords, action.payload) : [action.payload];           
            sortArrayByKey(ulData,"State");
            obj = Object.assign({}, obj, {UserLicenses : ulData});
            return Object.assign({}, state, { userInfo: obj });
        }

        case DELETE_USER_LICENSE_SUCCESS: {
            let obj = Object.assign({}, state.userInfo);            
            let UserLicensesData = obj.UserLicenses.filter(item => item.State != action.payload);
            obj = Object.assign({}, obj, {UserLicenses : UserLicensesData});
            return Object.assign({}, state, { userInfo: obj });
        }

        default:
            return state;
    }
}
